import {
  DELETE_CHARACTER_ATTRIBUTE,
  DELETE_CHARACTER_LEGACY_CUSTOM_ATTRIBUTE,
  EDIT_CHARACTER_ATTRIBUTE_METADATA,
  REORDER_CHARACTER_ATTRIBUTE_METADATA,
  LOAD_ATTRIBUTES,
} from '../constants/ActionTypes'

/**
 * @typedef {import('../types/plottr').AttributeType} AttributeType
 * @typedef {import('../types/plottr').Attribute} Attribute
 * @typedef {import('../types/plottr').Attributes} Attributes
 */

/**
 * @typedef {ReturnType<typeof editCharacterAttributeMetadata> | ReturnType<typeof deleteCharacterAttribute> | ReturnType<typeof deleteCharacterAttirbuteAdaptor> | ReturnType<typeof reorderCharacterAttribute> | ReturnType<typeof load>} AttributesActions
 */

/**
 * @param {number | Null} id The id of the *new* attribute to edit
 * @param {String} name
 * @param {AttributeType | 'base-attribute'} type
 * @param {String} oldName
 * @return {{ type: 'EDIT_CHARACTER_ATTRIBUTE_METADATA', id: number | Null, name: String, oldName: String, attributeType: AttributeType | 'base-attribute' }}
 */
export const editCharacterAttributeMetadata = (id, name, type, oldName) => {
  return {
    type: EDIT_CHARACTER_ATTRIBUTE_METADATA,
    id,
    name,
    oldName,
    attributeType: type,
  }
}
/**
 * @param {number} index
 * @param {Attribute} oldAttribute
 * @param {Attribute} newAttribute
 * @return {ReturnType<typeof editCharacterAttributeMetadata>}
 */
export const editCharacterAttributeMetadataAdaptor = (index, oldAttribute, newAttribute) => {
  return editCharacterAttributeMetadata(
    oldAttribute.id,
    newAttribute.name,
    newAttribute.type,
    oldAttribute.name
  )
}

/**
 * @param {number?} id
 * @param {String?} name
 * @return {{ type: 'DELETE_CHARACTER_LEGACY_CUSTOM_ATTRIBUTE', attributeName: String } | { type: 'DELETE_CHARACTER_ATTRIBUTE', id: number } | { type: 'NO_OPERATION' }}
 */
export const deleteCharacterAttribute = (id, name) => {
  if (name && !id) {
    return {
      type: DELETE_CHARACTER_LEGACY_CUSTOM_ATTRIBUTE,
      attributeName: name,
    }
  } else if (id) {
    return {
      type: DELETE_CHARACTER_ATTRIBUTE,
      id,
    }
  } else {
    return { type: 'NO_OPERATION' }
  }
}
/**
 * @param {String?} name
 * @param {number?} id
 * @return {{ type: 'DELETE_CHARACTER_LEGACY_CUSTOM_ATTRIBUTE', attributeName: String } | { type: 'DELETE_CHARACTER_ATTRIBUTE', id: number } | { type: 'NO_OPERATION' }}
 */
export const deleteCharacterAttirbuteAdaptor = (name, id) => {
  return deleteCharacterAttribute(id, name)
}

/**
 * @param {number?} attributeId
 * @param {number} toIndex
 * @param {String?} attributeName
 * @return {{ type: 'REORDER_CHARACTER_ATTRIBUTE_METADATA', attributeId: number | Null, toIndex: number, attributeName: String | Null }}
 */
export function reorderCharacterAttribute(attributeId, toIndex, attributeName) {
  return {
    type: REORDER_CHARACTER_ATTRIBUTE_METADATA,
    attributeId,
    toIndex,
    attributeName,
  }
}

/**
 * @param {boolean} patching
 * @param {Attributes} attributes
 * @return {{ type: 'LOAD_ATTRIBUTES', attributes: Attributes, patching: boolean }}
 */
export function load(patching, attributes) {
  return { type: LOAD_ATTRIBUTES, attributes, patching }
}
